import * as yup from 'yup';

import { i18n } from 'i18n';
import { ChangePasswordFormValues } from '../types';

export const getValidationSchema = (): yup.SchemaOf<ChangePasswordFormValues> =>
  yup.object({
    newPassword: yup
      .string()
      .required(
        i18n.t('fieldCannotBeEmpty', {
          name: i18n.t('pages.forgotPassword:newPassword'),
          interpolation: { escapeValue: false },
        })
      )
      .min(8, i18n.t('messages.forgotPassword:incorrectPasswordLength'))
      .matches(
        /(?=[A-Za-z0-9@#$%^&+!=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+!=]).*$/,
        i18n.t('messages.forgotPassword:incorrectPassword')
      ),
    confirmPassword: yup
      .string()
      .required(
        i18n.t('fieldCannotBeEmpty', {
          name: i18n.t('pages.forgotPassword:confirmPassword'),
          interpolation: { escapeValue: false },
        })
      )
      .oneOf(
        [yup.ref('newPassword'), null],
        i18n.t('messages.forgotPassword:passwordsDoNotMatch')
      ),
  });
